module.exports = __webpack_public_path__ + "static/img/gmnscss.ca42989.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gmnscss.jpg
// module id = M9I4
// module chunks = 31